import { putTrivia } from './api'

export const createTriviaQuestions = async (id, count) => {
  const response = await putTrivia(id, count)

  return response
}
